import React, { useEffect, useRef } from 'react';
import Type from 'prop-types';
import { useSnackbar } from 'notistack';
import { useHistory, useParams } from 'react-router-dom';
import { AddButton, ActivityIndicator, EmptyState } from 'components';
import { useTranslation } from 'hooks';
import { useTasks } from 'hooks/api/cascade';
import { useAbortRequest } from 'utils/useAbortRequest';
import { TaskList } from './components';

const TaskListScreen = (props) => {
  const { listHeight } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const { entityId } = useParams();
  const { abortSignal } = useAbortRequest();
  const {
    status,
    isError,
    error,
    data: tasks,
  } = useTasks(entityId, abortSignal);
  const listRef = useRef(null);

  useEffect(() => {
    if (isError) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  }, [isError]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCreateNewTask = () => {
    const url = `/cascades/${entityId}/tasks/new`;
    history.push(url);
  };

  const renderEmptyState = () => {
    return <EmptyState title={t('noTasksByCurrentCustomer')} />;
  };

  const renderTaskList = () => {
    return <TaskList ref={listRef} listHeight={listHeight} tasks={tasks} />;
  };

  const renderTasks = () => {
    const hasTasks = tasks.length !== 0;

    return (
      <>
        {hasTasks ? renderTaskList() : renderEmptyState()}

        <AddButton
          aria-label={t('createNewTask')}
          onClick={handleCreateNewTask}
        />
      </>
    );
  };

  const renderFetchState = () => {
    switch (status) {
      case 'loading':
        return <ActivityIndicator />;
      case 'success':
        return renderTasks();
      default:
        return null;
    }
  };

  return <>{renderFetchState()}</>;
};

TaskListScreen.propTypes = {
  listHeight: Type.number.isRequired,
};

export default TaskListScreen;
